export default {
    parts: [
        'container',
        'PreTitleStyle',
        'TitleStyle',
        'DescriptionStyle',
        'cta',
        'link'
    ],
    baseStyle: (props) => ({
        container: {
            position: props?.position,
            zIndex: '1',

            // Default or bottom/left alignment
            ...(props?.Alignment === "" || props?.Alignment === "bottom/left" && props?.position !== 'static' && {
                bottom: { base: 0 },
                left: { base: 0 },
                textAlign: { base: 'left' },
                paddingBottom: { base: '75px' },
            }),

            /* bottom/center */
            ...(props?.Alignment === "bottom/center" && props?.position !== 'static' && {
                bottom: { base: 0 },
                left: { base: '50%' },
                transform: { base: 'translateX(-50%)' },
                textAlign: { base: 'center' },
                paddingBottom: { base: '75px' },
            }),

            /* bottom/right */
            ...(props?.Alignment === "bottom/right" && props?.position !== 'static' && {
                bottom: { base: 0 },
                right: { base: 0 },
                textAlign: { base: 'right' },
                paddingBottom: { base: '75px' },
            }),

            /* center/right */
            ...(props?.Alignment === "center/right" && props?.position !== 'static' && {
                top: { base: '50%' },
                right: { base: 0 },
                transform: { base: 'translate(0, -50%)' },
                textAlign: { base: 'right' },
            }),

            /* top/right */
            ...(props?.Alignment === "top/right" && props?.position !== 'static' && {
                top: { base: 0 },
                right: { base: 0 },
                textAlign: { base: 'right' },
                paddingTop: { base: 6 },
            }),

            /* top/center */
            ...(props?.Alignment === "top/center" && props?.position !== 'static' && {
                top: { base: 0 },
                left: { base: '50%' },
                transform: { base: 'translate(-50%, 0)' },
                textAlign: { base: 'center' },
                paddingTop: { base: 6 },
            }),

            /* top/left */
            ...(props?.Alignment === "top/left" && props?.position !== 'static' && {
                top: { base: 0 },
                left: { base: 0 },
                textAlign: { base: 'left' },
                paddingTop: { base: 6 },
            }),

            /* center/center */
            ...(props?.Alignment === 'center/center' && props?.position !== 'static' && {
                textAlign: { base: 'center' },
                top: { base: '50%' },
                left: { base: '50%' },
                transform: { base: 'translate(-50%, -50%)' }
            }),

            paddingLeft: { base: 4, lg: 6 },
            paddingRight: { base: 4, lg: 6 },
            width: props?.BlockWidth && props?.BlockWidth !== '' ? props?.BlockWidth : 'max-content',
            maxWidth: '100%'
        },
        PreTitleStyle: {
            fontSize: { base: 'xs' },
            lineHeight: { base: '15px' },
            marginBottom: { base: 2 }
        },
        TitleStyle: {
            fontSize: { base: '32px' },
            lineHeight: { base: '34px' },
            fontWeight: { base: 'bold' },
            marginBottom: { base: 4, lg: 3 },
            ...(props?.TitleShadowEffect && {
                textShadow: '0px 4px 13px rgb(0 0 0 / 0.5)'
            })
        },
        DescriptionStyle: {
            fontSize: { base: 'md ' },
            lineHeight: { base: '24px' },
            marginBottom: { base: 4 }
        },
        cta: {
            fontSize: { base: 'sm', lg: 'md' },
            lineHeight: { base: '100%', lg: '20px' },
            letterSpacing: { base: '2%' },
            paddingTop: { base: '10px' },
            paddingBottom: { base: '10px' },
            paddingLeft: { base: 8, lg: 10 },
            paddingRight: { base: 8, lg: 10 },
            height: { base: 'auto' },
            minHeight: { base: '40px' },
            cursor: { base: 'pointer' },
            backgroundColor: { base: props?.CTABackgroundColor || 'webButton.btnPrimaryDefault' },
            color: { base: props?.TextColor || 'webTypo.textPrimaryReverse' },
            textDecoration: { base: props?.Underline ? 'underline' : 'none' },
            letterSpacing: '0%',
            ...(props?.Styling === 'Outlined' && {
                backgroundColor: { base: props?.CTABackgroundColor && props?.CTABackgroundColor !== '' ? props?.CTABackgroundColor : 'transparent' },
            }),
            _hover: {
                textDecoration: { base: 'none' }
            }
        },
        link: {
            fontSize: { base: 'sm', lg: 'md' },
            lineHeight: { base: '100%', lg: '20px' },
            fontWeight: { base: 'bold' },
            color: { base: props?.TextColor || 'webTypo.textPrimary' },
            textDecoration: { base: props?.Underline ? 'underline' : 'none' },
            _hover: {
                color: { base: props?.TextColor || 'webTypo.textPrimary' }
            }
        }
    }),
    variants: {
        'Button': {
            cta: {
                _hover: {
                    backgroundColor: 'webButton.btnPrimaryHover',
                    color: 'webTypo.textPrimaryReverse'
                },
                _active: {
                    backgroundColor: 'webButton.btnPrimaryHover',
                    color: 'webTypo.textPrimaryReverse'
                }
            }
        },
        'Outlined': {
            cta: {
                _hover: {
                    backgroundColor: 'webButton.btnSecondaryHover',
                    color: 'webTypo.textPrimaryReverse'
                },
                _active: {
                    backgroundColor: 'webButton.btnSecondaryHover',
                    color: 'webTypo.textPrimaryReverse'
                }
            }
        }
    }
}
